import { render, staticRenderFns } from "./FuneralWishes.vue?vue&type=template&id=5409c62e"
import script from "./FuneralWishes.vue?vue&type=script&lang=js"
export * from "./FuneralWishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports